import React, { useState } from 'react';
import { Typography, Form, Input, Button, Alert } from 'antd';
import axios from "../common/axios";
import CircularLoader from "../common/CircularLoader";

const { Title, Paragraph } = Typography;

const ClassKey = () => {
    const [form] = Form.useForm();
    const [isDisabled, setIsDisabled] = useState(true);
    const [isLoading, setLoading] = useState(false);
    const [statusMessage, setStatusMessage] = useState('');
    const [isSuccess, setSuccess] = useState(false);

    const handleValuesChange = (changedValues, allValues) => {
        setIsDisabled(!allValues.classCode);
        setStatusMessage(undefined);
    };

    const handleSubmit = (values) => {
        setLoading(true);
        setIsDisabled(true);
        setStatusMessage(undefined);
        axios
            .post('/web/ui/myClasses/connectWithClassCode', {
                classCode: values.classCode,
            })
            .then((response) => {
                setSuccess(response.data.success);
                if (response.data.success === false) {
                    setStatusMessage(response.data.message || 'Error validating class key');
                    setIsDisabled(false);
                } else {
                    setStatusMessage(response.data.message || 'Successfully connected to class');
                }
            })
            .catch((error) => {
                console.error('Error validating class code:', error);
                setStatusMessage('An error occurred while submitting your class key.');
                setSuccess(false);
            }).finally(() => {
                setLoading(false);
            });
    };

    return (
        <div id="classKey">
            <h2>Enter your class key</h2>
            <Paragraph>
                Your class key is a randomly generated word followed by 3 digits e.g. <em>apple123</em>.
                When your teacher/administrator creates a class in the School classes area,
                a unique class key is generated. This class key will appear next to the relevant class.
            </Paragraph>
            <Paragraph>
                If you missed entering your class key when you first registered, you can enter it here:
            </Paragraph>

            <Form
                id="classKeyForm"
                name="classKeyForm"
                form={form}
                layout="inline"
                onFinish={handleSubmit}
                onValuesChange={handleValuesChange}
            >
                <Form.Item
                    label="Class key"
                    name="classCode"
                    rules={[
                        { required: true, message: 'Please enter your class key' },
                        { min: 5, message: 'Class key must be at least 5 characters' },
                        { max: 10, message: 'Class key cannot exceed 10 characters' },
                    ]}
                    style={{ marginRight: 12 }}
                >
                    <Input disabled={isLoading} maxLength={10} placeholder="e.g. apple123" />
                </Form.Item>

                <Form.Item>
                    <Button type="primary" htmlType="submit" disabled={isDisabled}>
                        Submit
                    </Button>
                </Form.Item>
            </Form>
            <CircularLoader visible={isLoading} pageCentered={true} displayInElement={true}/>

            {statusMessage && (
                <div style={{ marginTop: 16 }}>
                    <Alert message={statusMessage} type={isSuccess ? 'success' : 'error'} showIcon />
                </div>
            )}
        </div>
    );
};

export default ClassKey;
